"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import IImportation from "@/interfaces/importation.interface";
import { ImportationsMessages } from "@/messages/importations/importations.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ImportationTableRow } from "./row";
import { IMPORTATIONS_TABLE_COLUMNS } from "../../constants";

interface Props {
  data: PaginatedResponse<IImportation>;
  pagination: Pagination;
  messages: ImportationsMessages;
}

export function ImportationTable({ data, pagination, messages }: Props) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {IMPORTATIONS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items &&
              data.items.map((importItem, index) => (
                <ImportationTableRow
                  key={`${index} - ${importItem.id}`}
                  importation={importItem}
                  index={index}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
